var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "resultsWrapper", staticClass: "grid-container full" },
    [
      _c(
        "div",
        {
          ref: "resultsWrapperInner",
          class: [
            "grid-x",
            "grid-margin-x",
            "grid-margin-y",
            "initialized",
            "dc-post-grid-results-inner",
            {
              loading: _vm.loading
            }
          ],
          attrs: { "aria-live": "polite" }
        },
        [
          _vm.results.length === 0
            ? _c("p", [_vm._v(_vm._s(_vm.dctxt("noResultsMessage")))])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.results, function(result, index) {
            return _c(
              "div",
              {
                key: "result-" + index,
                ref: "resultsWrapperInnerAlt",
                refInFor: true,
                class: ["cell"]
              },
              [
                _c("default", {
                  style: { zIndex: _vm.results.length - index },
                  attrs: {
                    id: result.id,
                    title: result.title,
                    excerpt: result.excerpt,
                    url: result.url,
                    image: result.image,
                    label: result.label
                  }
                })
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.showLoadMore && !_vm.endOfResults && !_vm.usesPagination
        ? _c("LoadMore", {
            attrs: {
              loading: _vm.loading,
              currentPaged: _vm.currentPaged,
              searchButtonId: _vm.searchButtonId
            },
            on: { "update-current-paged": _vm.updateCurrentPaged }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLoadMore && _vm.usesPagination
        ? _c("Pagination", {
            attrs: {
              loading: _vm.loading,
              currentPaged: _vm.currentPaged,
              totalPages: _vm.totalPages,
              postNavigationType: _vm.postNavigationType
            },
            on: { "update-current-paged": _vm.updateCurrentPaged }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }